var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconOpenExternal = function SvgIconOpenExternal(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.68 4.5v1.68h2.968l-8.164 8.164 1.172 1.172 8.164-8.164v2.968h1.68V4.5zm4.14 13.32H6.18V6.18H12V4.5H6.18q-.743 0-1.211.508-.47.468-.469 1.172v11.64q0 .704.469 1.211.507.47 1.21.469H17.82q.704 0 1.172-.469.508-.508.508-1.21V12h-1.68z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconOpenExternal);
export { ForwardRef as ReactComponent };